const INPUT_TAG_NAMES = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

const INPUT_CLASS_NAMES = [
  'MuiInputBase-input',
  'MuiInput-input',
  'MuiOutlinedInput-input',
  'MuiFilledInput-input',
];

/**
 * 入力系要素かどうかを判定する
 */
export const isInputLikeElement = (target: EventTarget | null): target is HTMLElement => {
  if (!(target instanceof HTMLElement)) {
    return false;
  }

  if (INPUT_TAG_NAMES.has(target.tagName)) {
    return true;
  }

  if (target.isContentEditable || target.getAttribute('contenteditable') === 'true') {
    return true;
  }

  return INPUT_CLASS_NAMES.some((className) => target.classList.contains(className));
};

/**
 * アクティブ要素が入力系かどうか
 */
export const hasInputLikeFocus = (): boolean => {
  return isInputLikeElement(document.activeElement);
};

/**
 * フォーカス中の入力要素をブラーする
 */
export const blurActiveInputLikeElement = (): boolean => {
  const activeElement = document.activeElement;
  if (!isInputLikeElement(activeElement)) {
    return false;
  }

  activeElement.blur();
  return true;
};
